import Tool from '../Tool';
import eventUtil from '../util/events';

/** Snap Handle */
export default class SnapHandle extends Tool {
	constructor(core, panel) {
		super(core);
		this.panel = panel;
		this.params = this._getDefaultParams();
	}

	_getDefaultParams() {
		return {
			id: 'snapHandle',
			name: 'Snap Handle',
			style: this.core.getStyle('tool.snapHandle')
		};
	}

	getCoords(mouse) {
		// get nearest date
		const panel = this.panel;
		const core = panel.core;
		const rulerIdx = Math.round(panel.xAxis.primaryScale.invert(mouse[0]));
		const snapDistance = 20;
		let snapCoords = null;
		const isOHLC = /candlestick|ohlc/.test(
			panel.indicators[0].params.markerType
		);
		let yOpen;
		let yHigh;
		let yLow;
		let distOpen;
		let distHigh;
		let distLow;

		if (core.exchangeDates[rulerIdx]) {
			const dataIdx = core._getIndexByDate(
				core.dataPrimary,
				new Date(core.exchangeDates[rulerIdx])
			);

			if (core.dataPrimary[dataIdx]) {
				const yScale = panel.yAxis.primaryScale;
				const searchData = [];

				// search the index to the left
				if (core.dataPrimary[dataIdx - 1]) {
					searchData.push(core.dataPrimary[dataIdx - 1]);
				}

				// search the index to the right
				if (core.dataPrimary[dataIdx + 1]) {
					searchData.push(core.dataPrimary[dataIdx + 1]);
				}

				// search main index
				searchData.push(core.dataPrimary[dataIdx]);

				// search for the closest point of up to 3 ohlc sets
				for (let x = 0; x < searchData.length; x++) {
					// get OHLC coords
					const yClose = yScale(searchData[x].close);
					const xData = panel.xAxis.primaryScale(
						core.closestExchangeIndex(searchData[x].date)
					);
					const distClose = this.distance(mouse, [xData, yClose]);
					let min = distClose;

					if (isOHLC) {
						yOpen = yScale(searchData[x].open);
						yHigh = yScale(searchData[x].high);
						yLow = yScale(searchData[x].low);

						distOpen = this.distance(mouse, [xData, yOpen]);
						distHigh = this.distance(mouse, [xData, yHigh]);
						distLow = this.distance(mouse, [xData, yLow]);

						min = Math.min(
							min,
							distOpen,
							distHigh,
							distLow,
							distClose
						);
					}

					// when close enough, snap to closest ohlc point
					if (min < snapDistance) {
						if (min === distClose) {
							snapCoords = [xData, yClose];
						}

						if (isOHLC) {
							if (min === distHigh) {
								snapCoords = [xData, yHigh];
							} else if (min === distLow) {
								snapCoords = [xData, yLow];
							} else if (min === distOpen) {
								snapCoords = [xData, yOpen];
							}
						}
					}
				}
			}
		}

		return snapCoords;
	}

	distance(coord1, coord2) {
		let xs = coord2[0] - coord1[0];
		let ys = coord2[1] - coord1[1];

		xs *= xs;
		ys *= ys;

		return Math.sqrt(xs + ys);
	}

	render(event) {
		const mouse = eventUtil.getMouseFromDomEvent(event);
		if (this.renderCustom) {
			return this.renderCustom(mouse);
		}

		this.coords = this.getCoords(mouse);

		if (this.coords) {
			const panel = this.panel;
			const ctx = panel.rootToolContext;
			const size = 2;

			ctx.beginPath();
			ctx.lineWidth = 1;
			ctx.strokeStyle = this.params.style.color;

			ctx.arc(
				this.coords[0] - size / 2 + 1,
				this.coords[1] - size / 2 + 1,
				size * 2,
				0,
				2 * Math.PI
			);
			ctx.stroke();
		}
	}
}
